import React, { useState, useCallback } from 'react';
import SessionToast from '../SessionToast/SessionToast';

let toastId = 0;

const ToastManager = () => {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, type = 'success', duration = 3000) => {
    const id = ++toastId;
    const toast = { id, message, type, duration };
    
    setToasts(prev => [...prev, toast]);
    
    return id;
  }, []);

  const removeToast = useCallback((id) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  }, []);

  // Make showToast function globally available
  React.useEffect(() => {
    window.showToast = showToast;
    
    return () => {
      delete window.showToast;
    };
  }, [showToast]);

  return (
    <div className="fixed top-0 right-0 z-50 p-4 space-y-2 pointer-events-none">
      {toasts.map((toast, index) => (
        <div 
          key={toast.id} 
          className="pointer-events-auto"
          style={{ 
            transform: `translateY(${index * 70}px)`,
            transition: 'transform 0.3s ease-out'
          }}
        >
          <SessionToast
            message={toast.message}
            type={toast.type}
            duration={toast.duration}
            onClose={() => removeToast(toast.id)}
          />
        </div>
      ))}
    </div>
  );
};

export default ToastManager; 